import React from 'react';
import { NotificationsAnalyticsContext } from '@atlaskit/analytics-namespaced-context';
import { NotificationsStoreContext } from '../../ui/notifications-context';
import { NotificationsExperienceTracker } from '../experience-tracking';
import NotificationIntlProvider from '../i18n/intl-provider';
export var NotificationsCommonProviders = function NotificationsCommonProviders(_ref) {
  var defaultAnalyticsContextData = _ref.defaultAnalyticsContextData,
    analyticsContext = _ref.analyticsContext,
    userId = _ref.userId,
    packageName = _ref.packageName,
    packageVersion = _ref.packageVersion,
    children = _ref.children;
  var intlLocaleRef = React.useRef('en-US');
  var updateIntlLocaleRef = function updateIntlLocaleRef(intlLocale) {
    intlLocaleRef.current = intlLocale;
  };
  return /*#__PURE__*/React.createElement(NotificationsStoreContext.Provider, {
    value: {
      userId: userId,
      analyticsContext: analyticsContext,
      packageName: packageName,
      packageVersion: packageVersion,
      intlLocale: intlLocaleRef,
      updateIntlLocale: updateIntlLocaleRef
    }
  }, /*#__PURE__*/React.createElement(NotificationIntlProvider, null, /*#__PURE__*/React.createElement(NotificationsAnalyticsContext, {
    data: defaultAnalyticsContextData
  }, /*#__PURE__*/React.createElement(NotificationsExperienceTracker, null, children))));
};